import React from "react";
import { Route, Routes } from "react-router-dom";
import SupplierInvoice from "../pages/Inventory/SupplierInvoice";
import NewStockInvoice from "../pages/Inventory/NewStockInvoice";
import EditInvoice from "../pages/Inventory/EditInvoice";
import SupplierInvoiceDetail from "../pages/Inventory/SupplierInvoice/SupplierInvoiceDetail";
import ProcessInvoice from "../pages/Inventory/ProcessInvoice";

const InvoiceRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<SupplierInvoice />} />
      <Route path="/new" element={<NewStockInvoice />} />
      <Route path="/:invoice_id/edit" element={<EditInvoice />} />
      <Route path="/:invoice_id/details" element={<SupplierInvoiceDetail />} />
      <Route path="/process" element={<ProcessInvoice />} />
    </Routes>
  );
};

export default InvoiceRoutes;
